import React from "react";

const ConfirmArchiveModal = ({
  isOpen,
  onCancel,
  onConfirm,
  entityName = "Record",
  title,
  description,
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="drawer-overlay" />
      <div
        className="entity-drawer modal-popup-cls"
        // ref={archivedRef}
        style={{
          maxWidth: 650,
          margin: "0 auto",
          background: "white",
          borderRadius: 12,
          zIndex: 1050,
          padding: 24,
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
          height: "auto",
          right: "auto",
          overflow: "inherit",
        }}
      >
        <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
          <button
            onClick={onCancel}
            style={{
              background: "none",
              border: "none",
              padding: 0,
              cursor: "pointer",
              outline: "none",
            }}
            onFocus={(e) => e.target.blur()} // optional: removes focus highlight instantly
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <h3
          style={{
            textAlign: "left",
            color: "#212529",
            fontSize: "20px",
            fontWeight: "600",
            lineHeight: "24px",
            fontFamily: "Montserrat",
            marginBottom: "10px",
            // paddingTop:'20px'
          }}
        >
          {/* {entityName === "Stock"
    ? `Confirm to archive this ${entityName}?`
    : `Confirm to archive this ${entityName}`} */}

       {title || (
  entityName === "Trade-In Listing"
    ? "Confirm to archive this Listing?"
    : entityName === "Stock" || entityName === "Listing"
      ? `Confirm to archive this ${entityName}?`
      : entityName === "SPU and its SKUs"
        ? "Confirm to archive this SPU?"
        : `Confirm to archive this ${entityName}`
)}
          
        </h3>
        <p
          style={{
            marginBottom: "0",
            textAlign: "left",
            color: "#6C757D",
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "20px",
            fontFamily: "Montserrat",
            paddingBottom:'20px'
          }}
        >
          {description || (
            entityName === "Stock"
              ? "After archiving, all StockInstances in this Stock will be archived too. This action cannot be undone."
              : entityName === 'SPU and its SKUs'
                ? `Once archived, this ${entityName} can no longer be retrieved.`
                : entityName === 'Trade-In Listing'
                  ? "Once archived, this Listing and all its Items can no longer be listed on downstream platforms. This action cannot be undone."
                  : `Once archived, the ${entityName} can no longer be retrieved.`
          )}
          </p>
        <div className="drawer-footer" style={{ paddingTop: "10px", paddingBottom: '10px' }}>
          <button
            onClick={onCancel}
            style={{
              display: "flex",
              height: "34px",
              minWidth: "100px",
              padding: "10px",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              borderRadius: "8px",
              border: entityName === 'SPU and its SKUs' ? 'none' : '1px solid var(--navbar-dropdown-active, #212529)',
              // border: "1px solid  var(--navbar-dropdown-active, #212529)",
              background: "var(--Background-White, #FFF)",
              boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.10)",
              color: "var(--navbar-dropdown-active, #212529)",
              fontFamily: "Montserrat",
              fontSize: "12px",
              fontWeight: 600,
              fontStyle: "normal",
              lineHeight: "normal",
            }}
            onMouseDown={(e) => e.stopPropagation()}
          >

            Cancel
          </button>

          <button
            onClick={onConfirm}
            style={{
              display: "flex",
              height: "34px",
              minWidth: "100px",
              padding: "10px",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              borderRadius: "8px",
              background: "var(--navbar-dropdown-active, #212529)",
              boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.10)",
              color: "var(--Background-White, #FFF)",
              fontFamily: "Montserrat",
              fontSize: "12px",
              fontWeight: 600,
              fontStyle: "normal",
              lineHeight: "normal",
            }}
            onMouseDown={(e) => e.stopPropagation()}
          >
            Confirm
          </button>
        </div>
      </div>
    </>
  );
};

export default ConfirmArchiveModal;